<template>
  <div>
    <load-profile />
    <!-- Table Container Card -->
    <b-card>
      <b-row>
        <b-col
          cols="12"
          class="text-right"
        >
          <b-button
            v-if="$can('update', 'video-live-upload')"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="primary"
            class="mb-1"
            :to="{
              name: 'update-match-video',
              params: { id: $route.params.id },
            }"
          >
            <feather-icon icon="EditIcon" />
            {{ $t("button.update") }}
          </b-button>
        </b-col>
      </b-row>
      <n-input-view
        v-model="data"
        :fields="fields"
        :init-value="initData"
      >
        <template #file>
          <BButton
            :href="data.videoUrl"
            target="_blank"
            class="mb-2"
            variant="primary"
          >
            Play Video
          </BButton>
        </template>
        <template #result="item">
          <b-form-group
            :label-for="item.field.key"
            class="fightResult"
          >
            <validation-provider
              #default="{ errors }"
              :vid="item.field.key"
              :name="$t(item.field.label)"
              :rules="item.field.rules"
            >
              <label>
                {{ $t(item.field.label) }}
              </label>
              <div>
                <b-form-radio-group
                  id="result"
                  v-model="data[item.field.key]"
                  :name="item.field.key"
                  buttons
                  button-variant="outline-primary"
                  disabled
                >
                  <b-form-radio
                    v-for="option in resultOptions"
                    :key="option.value"
                    :class="`fightResult-${getFightResultById(option.value)}`"
                    :value="option.value"
                  >
                    {{ $t(option.text) }}
                  </b-form-radio>
                </b-form-radio-group>
              </div>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </template>
      </n-input-view>
      <b-row>
        <b-col
          cols="12"
          class="text-right"
        >
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="outline-secondary"
            class="mt-1"
            @click="back"
          >
            {{ $t("button.back") }}
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { BButton, BCard, BCol, BFormGroup, BFormRadio, BFormRadioGroup, BRow, } from 'bootstrap-vue'
import Repository from '@/repositories/RepositoryFactory'
import Ripple from 'vue-ripple-directive'
import NInputView from '@/components/NInputView.vue'
import FormInput from './formInput'

const MatchVideoRepository = Repository.get('matchVideo')

export default {
  components: {
    BFormRadio,
    BButton,
    BFormGroup,
    BRow,
    BCol,
    BCard,
    BFormRadioGroup,
    NInputView,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      data: {
        channelId: null,
        result: null,
        betTime: null,
        fullTime: null,
        isEnable: true,
      },
      initData: {},
      loading: false,
    }
  },
  computed: {
    resultOptions() {
      return [
        { text: 'field.meron', value: 1 },
        { text: 'field.draw', value: 3 },
        { text: 'field.wala', value: 2 },
      ]
    },
  },
  mounted() {
    this.show()
  },
  methods: {
    getFightResultById(id) {
      if (id === 1) {
        return 'meron'
      } if (id === 2) {
        return 'wala'
      } if (id === 3) {
        return 'draw'
      } if (id === 4) {
        return 'cancel'
      }

      return ''
    },
    show() {
      MatchVideoRepository.show(this.$route.params.id).then(response => {
        if (response?.data?.data) {
          this.initData = {
            ...response.data.data,
          }
        }
      })
    },
    back() {
      this.$router.back()
    },
  },
  setup() {
    const fields = [...FormInput]

    return { fields }
  },
}
</script>
